import React, { Suspense, useDeferredValue } from 'react';

import dynamic from 'next/dynamic';

import { useSelector } from 'react-redux';
import SpinLoader from '../SpinLoader';

import styles from './Auth.module.scss';

// Components
const LoginComponent = dynamic(() => import('./Login'));
const ExamPreferenceComponent = dynamic(() => import('./ExamPreference'));

function AuthComponent() {
  const { showLogin, authView } = useSelector((state) => state?.auth);

  const deferredShowLogin = useDeferredValue(showLogin);

  return (
    <div className={`${styles.authModalWrapper} ${showLogin ? 'show' : ''}`}>
      <div id="auth-modal" className={styles.authModal}>
        {deferredShowLogin && (
          <Suspense fallback={<SpinLoader />}>
            {authView === 'AUTHENTICATION' && <LoginComponent />}
            {authView === 'EXAM_PREF' && <ExamPreferenceComponent />}
          </Suspense>
        )}
      </div>
    </div>
  );
}

export default AuthComponent;
